exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ .dialog-wrapper-content {\n  padding: 0px !important;\n  min-height: unset !important;\n  width: auto !important; }\n\n.box-detail .title {\n  padding: 20px 10px 5px;\n  font-weight: bold;\n  color: #042764; }\n\n.box-detail .row {\n  margin: 0;\n  padding: 10px 20px; }\n  .box-detail .row:first-child {\n    padding: 0; }\n  .box-detail .row:nth-last-child(2) {\n    padding: 10px;\n    color: #042764 !important; }\n  .box-detail .row:last-child {\n    border-top: 1px solid #DFE1E6; }\n  .box-detail .row span {\n    color: #6b778c !important; }\n  .box-detail .row .row-summary {\n    padding: 10px;\n    background-color: #F6F8F9; }\n  .box-detail .row .btn-close {\n    text-align: center; }\n  .box-detail .row .co-budget-note {\n    font-size: 14px;\n    line-height: 18px;\n    color: #ed1c24; }\n\n.box-detail .col-xs-12,\n.box-detail .col-xs-8,\n.box-detail .col-xs-4 {\n  padding: 0; }\n\n.box-detail .col-xs-4 {\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-share-budget/dialog-share-budget-detail/dialog-share-budget-detail.component.scss
// module id = 934
// module chunks = 22